const truncateFilename = (filename, max = 32) => {
  if (!filename || filename.length <= max) return filename
  const extensionIndex = filename.lastIndexOf('.')
  if (extensionIndex === -1) return `${filename.slice(0, max - 1)}…`
  const extension = filename.slice(extensionIndex)
  const head = filename.slice(0, Math.max(4, max - extension.length - 1))
  return `${head}…${extension}`
}

export default truncateFilename
